export const Tabs = {
  Request: 'Opdracht',
  Messages: 'Berichten',
};
